export const maxLoaders = 5;